<template>
<article class="v-card" :class="shop.bgColor">
  <span class="image bgcover" :class="bgClass" :style="getImageStyle(shop)"></span>
  <a :href="`/shop/${removeSpecialCharsFromString(shop.title)}`" @click.prevent="onClickedShop(shop)"><!-- target="_blank" :href="shop.url" -->
    <h2 class="heading" :class="shop.headingColor">{{shop.title}}</h2>
    <div class="content clicked">
      <p>
        <span>
          <span v-html="(shortenDescr)?getShortenDescription(shop.descr,shop.title):shop.descr"></span>
          <br v-if="shop.company">
          <br v-if="shop.company">{{shop.company}}
        </span><br>
        <span v-if="!_.isEmpty(shop.ship)" class="">{{getAdditionalContent(shop)}}</span>
      </p>
    </div>
  </a>
</article>

<!--
						<lazy-background
							class="image bgcover"
							:image-source="getModifiedImage(shop.img)"
							loading-image="/images/pic05.jpg"
							error-image="/images/loader/puff.svg"
							image-class="cam-viewport"
							background-size="cover"
							>
						</lazy-background>-->
	

</template>

<script>
import {shopBase} from '@/mixins/shopBase.js'
import {helper} from '@/mixins/helper.js'
export default {
  name: 'RTshop',
  mixins:[helper,shopBase],
  props: {
    shop: Object,
    isTouchDevice:{
      type:Boolean,
      default:false
    },
    activeId:{
      type:String,
      default:null
    },
    bgClass:{
      type:String,
      default:null
    },
    shortenDescr:{
      type:Boolean,
      default:true
    }
  },
  data(){
    return{
      MAX_LENGTH:140
    }
  },
  methods:{
    onClickedShop(shop){
			if(shop){
       
				//One click on pcs AND 2 clicks on mobile devices
				if(this.isTouchDevice && this.activeId !=shop.id){
          this.$emit('touched',shop);
          return;
        }
        
        this.$router.push({ name: 'shop', params: { id: this.removeSpecialCharsFromString(shop.title) } })
			}
    },

    getShortenDescription(descr,title){
      if(descr && title){
        if((descr).length>this.MAX_LENGTH){
          descr=descr.substring(0,this.MAX_LENGTH) + '...'
        }
      }
      return descr;
    },

    getAdditionalContent(row){
      let res="";
      if(row){
        //if((row.title+row.descr).length<=this.MAX_LENGTH){
          let contact=this.getTablerContact(row);
          if(contact!=""){
              res=contact;//"Kontakt: "+contact;
          }/*else{
              if(!this._.isEmpty(row.ship)){
                  res="Versand: "+this.getShippingAsString(row);
              }
          }*/
        }
      //}
      return res;
		},
  },
  /*
  beforeRouteEnter: (to,from,next) => {
		next(vm => {
			setTimeout(()=>{
				vm.scrollToTop();
			},500);
		});
  },
  */
  mounted(){

  }
}
</script>

<style scoped>

</style>
